import React from 'react';
import OtoAlertNew from 'Comps/common/OtoAlertNew';
import NewIcon from 'Icons/NewIcon';
var BombardinoSwitchRestaurantBanner = function (_a) {
    var restaurant = _a.restaurant;
    var bombardinoRestaurantsWithAddresses = [
        {
            id: 11,
            name: 'Bombardino Trattoria',
            location: 'Jana Pawła II 51',
        },
        {
            id: 530,
            name: 'Bombardino Trattoria Czechów',
            location: 'Północna 28c',
        },
    ];
    var isBombardino = bombardinoRestaurantsWithAddresses.some(function (r) { return r.id === restaurant.id; });
    if (!isBombardino) {
        return null;
    }
    var otherBombardinoRestaurants = bombardinoRestaurantsWithAddresses.filter(function (r) { return r.id !== restaurant.id; });
    return (React.createElement(OtoAlertNew, { color: "primary", className: "mb-1 mr-1 oto-alert--small", icon: React.createElement(NewIcon, { className: 'mr-2', style: { height: 36, width: 36 } }), closable: false },
        React.createElement("div", { className: 'd-flex flex-column align-items-start' },
            React.createElement("div", { className: 'mb-2' },
                "Zamawiasz z restauracji ",
                restaurant.name,
                " pod adresem ",
                restaurant.location),
            otherBombardinoRestaurants.map(function (restaurant) { return (React.createElement("a", { key: restaurant.id, href: "/restaurants/".concat(restaurant.id, "/iframe") },
                React.createElement("button", { className: "mode-toggler__btn", type: "button" },
                    "Prze\u0142\u0105cz na ",
                    restaurant.name,
                    " (",
                    restaurant.location,
                    ")"))); }))));
};
export default BombardinoSwitchRestaurantBanner;
